import React, { Component } from 'react';
import withAuthorization from '../../Session/withAuthorization';
import { db } from '../../../firebase';
import ReactTable from "react-table";
import { Input, Label, FormGroup, Form, Col, Row } from 'reactstrap';
import * as states from '../../../constants/states';
import { inject, observer } from 'mobx-react';
import { compose } from 'recompose';
import { functions } from '../../../firebase/firebase';
import Spinner from '../../Spinner';

const ComplainsTablePage = ({ sessionStore }) =>       
          <ComplainsTable authUser = {sessionStore.authUser} />
    

class ComplainsTable extends Component {

    constructor(props) {
        super(props);
    
        this.state = {
          complaints: [],
          showClosedComplains:true,
          isModerator:false,
          isLoading:true
        };
      }

    onChange(showClosedComplains){
        db.updateUsershowClosedComplainsSetting(this.props.authUser.uid, !this.state.showClosedComplains).then(()=>
            this.setState({showClosedComplains:!this.state.showClosedComplains})
        );
    }

    makePlaceholderFilter(filter, onChange,placeholder){
        return( <input type='text'
                placeholder={placeholder}
                value={filter ? filter.value : ''}
                onChange={event => onChange(event.target.value)}/>
            )
          
      }

    filterMethod( filter, row ){
        const   rowText = row[filter.id].toLowerCase();
        const   searchText = filter.value.toLowerCase();
        return  rowText.indexOf(searchText) !== -1;
    }
    
      componentDidMount() {

        var getComplains = functions.httpsCallable('getComplainsData');

        getComplains({userId:this.props.authUser.uid}).then(snapshotComplains =>{

            db.onceGetUser(this.props.authUser.uid).then( userSnapshot => {
                let user = userSnapshot.val();
                let options = { year: 'numeric', month: 'numeric', day: 'numeric', hour:'numeric', minute:'numeric' };
                let complaints = snapshotComplains.data;
    
                if(complaints){
                    Object.keys(complaints).map(key =>{
                        complaints[key].createDate = new Date(complaints[key].dateCreated).toLocaleDateString("lt-LT",options);
        
                        if(complaints[key].state === states.ComplainClosed){
                            complaints[key].endDate = new Date(complaints[key].dateEdited).toLocaleDateString("lt-LT",options);
                        }
    
                    });
                    return this.setState(() => ({ 
                        complaints: complaints,
                        showClosedComplains: user.showClosedComplains,
                        isLoading: false,
                        isModerator: user.customClaims.isModerator
                    })) 
                }
            })
        });
      }
    
    render() {

        const filterText = 'Ieškoti';

    //copy array
        let complaints = this.state.complaints.map(a => ({...a}));
        let { showClosedComplains, isLoading, isModerator } = this.state;

        Object.keys(complaints).map(key=>{
            if(!showClosedComplains && complaints[key].state === states.ComplainClosed){
                delete complaints[key]
            }
        })

        //refactor do something with table width

        const columns = [
        {
            Header: 'Tema',
            accessor: 'subject',
            Filter:({filter, onChange}) => this.makePlaceholderFilter(filter,onChange,filterText),
            filterMethod: (filter, row) => this.filterMethod(filter, row)            
        },
        {
            Header: 'Aprašymas',
            accessor: 'complainText',
            style: { 
                'whiteSpace': 'unset',
                'wordWrap': 'break-word' 
                },
            Filter:({filter, onChange}) => this.makePlaceholderFilter(filter,onChange,filterText),
            filterMethod: (filter, row) => this.filterMethod(filter, row)     
        },
        {
            Header: 'Sukūrimo data',
            accessor: 'createDate',
            width: 150,
            Filter:({filter, onChange}) => this.makePlaceholderFilter(filter,onChange,filterText) 
        },
        {
            Header: 'Uždarymo data',
            accessor: 'endDate',
            width: 150,
            Filter:({filter, onChange}) => this.makePlaceholderFilter(filter,onChange,filterText) 
        },
        {
            Header: 'Būsena',
            accessor: 'state',
            maxWidth: 130,
            Filter:({filter, onChange}) => this.makePlaceholderFilter(filter,onChange,filterText),
            filterMethod: (filter, row) => this.filterMethod(filter, row)
        },
        {
            Header: 'Komentaras',
            accessor: 'comment',
            style: { 
                'whiteSpace': 'unset',
                'wordWrap': 'break-word' 
                },
            Filter:({filter, onChange}) => this.makePlaceholderFilter(filter,onChange,filterText),
            filterMethod: (filter, row) => this.filterMethod(filter, row)
        }
        ]

        if(isModerator){
            columns.push({
                Header: "Vartotojas",
                accessor: "alias",
                Filter:({filter, onChange}) => this.makePlaceholderFilter(filter,onChange,filterText),
                filterMethod: (filter, row) => this.filterMethod(filter, row)
            })
        }

        if(isLoading){
            return(
            <Spinner></Spinner>);
        }
        else if(complaints === undefined || complaints.length === 0){
            return <p className = "text-center">Nėra incidentų</p>
        } else{
            return (
                <div>
                    <Row>
                        <Col className="checkbox-showClosedComplains">
                        <Form>
                            <FormGroup check>
                                <Label check>
                                    <Input type="checkbox" checked={showClosedComplains} onChange={() =>   
                                        this.onChange(!this.state.showClosedComplains)
                                    } />{' '}
                                    Rodyti išspręstus incidentus
                                </Label>
                            </FormGroup>
                        </Form>
                </Col>
                </Row>
                <Row>
                    <Col>
                        <ReactTable
                            data={complaints}
                            columns={columns}
                            minRows={0}
                            filterable={true}
                            defaultSorted={[
                                {
                                    id: "createDate",
                                    desc: true
                                }
                                ]}
                            defaultPageSize={5}
                            nextText={"Kitas"}
                            previousText={"Ankstesnis"} 
                            pageText={"Puslapis"}
                            ofText={"iš"}
                            rowsText={"eilutės"} 
                        />
                    </Col>
                </Row>
            </div>
            );
        }
    }
}

const authCondition = (authUser, token ) =>{
    return !!authUser;
} 

export default compose(
    withAuthorization(authCondition),
    inject('sessionStore'),
    observer
)(ComplainsTablePage);


// WEBPACK FOOTER //
// ./src/components/Complains/TableComplains/index.js